import React from "react";
import "./Pages.css";

const Disclaimer: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Disclaimer</h1>
      <p>
        The information on the The Destination Dreams Travel website
        (www.dreamstriphub.com) is provided for general informational purposes to
        help you plan and enquire about travel. While we strive to keep it accurate
        and up to date, we make no warranty as to its completeness or accuracy.
      </p>

      <h2>Prices and availability</h2>
      <ul>
        <li>
          Fares, rates, package prices and availability are indicative and subject to
          change without notice until a booking is confirmed and paid.
        </li>
        <li>
          All prices are quoted in Omani Rial (OMR) unless stated otherwise.
        </li>
      </ul>

      <h2>Third-party services</h2>
      <ul>
        <li>
          Flights, hotels, transfers, car hire and insurance are provided by
          independent third-party suppliers and are subject to their own terms and
          conditions.
        </li>
        <li>
          The Destination Dreams Travel acts as an intermediary and is not liable for
          changes, delays, cancellations or losses caused by these suppliers or by
          events beyond our control.
        </li>
      </ul>

      <h2>External links</h2>
      <p>
        Our website may contain links to external sites that we do not control; we
        are not responsible for their content or practices.
      </p>

      <p>
        For any clarification, contact us at +968 95987986 or
        team@dreamstriphub.com.
      </p>
    </div>
  );
};

export default Disclaimer;
